import { Button, Card, CardBody, CardFooter, Form, FormField, TextInput } from "grommet"
import RouletteDesignTab from "../tab/RouletteDesignTab"
import { useEffect, useState } from "react";
import { rouletteItemBgType, rouletteItemFrameType, roulettePinType } from "../../RouletteConstants";
import { useRouletteStyleContext } from "../context/RouletteStyleContextProvider";
import { FormTypeContext } from "../tab/RouletteItemDesignTab";
import { useUpdateRouletteWidgetMutation } from "../../../../api/rouletteWidgetApi";

const RouletteSettingsForm = ({ values }) => {

    const [updateRouletteWidget, { isLoading: isUpdatingRoulette, isSuccess: isRouletteUpdated }] = useUpdateRouletteWidgetMutation();

    const { setRouletteStyle } = useRouletteStyleContext();

    const [isSuccess, setSuccess] = useState(false);

    const [rouletteDesignForm, setRouletteDesignForm] = useState(values ? values : {
        backgroundType: rouletteItemBgType.COLOR,
        backgroundColor1: "#2f2f2f",
        backgroundColor2: "#2f2f2f",
        backgroundColorAngle: 180,
        backgroundRadius: 16,
        backgroundImage: '',
        backgroundImageHueRotate: 0,
        backgroundImageSaturate: 100,
        backgroundShadowColor: "black",
        backgroundShadowVerticalOffset: 0,
        backgroundShadowHorizontalOffset: 0,
        backgroundShadowBlur: 0,
        frameType: rouletteItemFrameType.OUTLINE,
        frameColor1: "#a10259",
        frameColor2: "#a10259",
        frameColorGradientAngle: 180,
        frameOutlineWidth: 6,
        frameRadius: 16,
        frameImage: null,
        frameImageHueRotate: 0,
        frameImageSaturate: 100,
        frameShadowColor: "black",
        frameShadowVerticalOffset: 0,
        frameShadowHorizontalOffset: 0,
        frameShadowBlur: 0,
        pinType: roulettePinType.VECTOR,
        pinImage: null,
        pinImageHue: 0,
        pinImageSaturation: 100,
        pinColor1: "#b300ff",
        pinColor2: "#b300ff",
        pinColorGradientAngle: 180,
        pinOutlineWidth: 2,
        pinOutlineColor: "#6e00ff",
        pinShadowColor: "black",
        pinShadowHorizontalOffset: 0,
        pinShadowVerticalOffset: 0,
        pinShadowBlur: 0
    });

    const handleRouletteDesignFormChange = (value) => {

        setRouletteDesignForm(value);
        setRouletteStyle(value);
    }

    useEffect(() => {
        if (isRouletteUpdated) {
            setSuccess(isRouletteUpdated)
            const timeoutId = setTimeout(() => setSuccess(false), 1500);

            return () => clearTimeout(timeoutId);
        }
    }, [isRouletteUpdated])

    return (
        <Card>
            <FormTypeContext.Provider value={{ backgroundType: rouletteDesignForm.backgroundType, frameType: rouletteDesignForm.frameType, pinType: rouletteDesignForm.pinType }}>
                <Form value={rouletteDesignForm} onChange={handleRouletteDesignFormChange} onSubmit={({ value }) => updateRouletteWidget(value)}>
                    <CardBody gap="small">
                        <RouletteDesignTab />
                    </CardBody>
                    <CardFooter justify="end" pad={{ top: 'none', left: 'medium', right: 'medium', bottom: 'medium' }}>
                        <Button label="Save" primary type="submit" busy={isUpdatingRoulette} success={isSuccess} />
                        {/* <Button label="Delete" /> */}
                    </CardFooter>
                </Form>
            </FormTypeContext.Provider>
        </Card>
    )
}

export default RouletteSettingsForm;